"use strict";

exports.__esModule = true;
exports.dataFormatter = void 0;

var _lowercasing = require("./lowercasing");

var _spaceToDash = require("./spaceToDash");

var _EmptyStringToNull = require("./EmptyStringToNull");

const dataFormatter = message => {
  let preparedMessage = (0, _EmptyStringToNull.convertEmptyStringToNull)((0, _spaceToDash.convertSpaceToDash)((0, _lowercasing.convertToLowerCasing)({ ...message
  })));
  return preparedMessage;
};

exports.dataFormatter = dataFormatter;